import GalleryHeading from "./GalleryHeading";

export default GalleryHeading;
